<template>
  <div v-if="data && data.length" class="form-data-view mt-3">
    <h6 class="mb-2">Дані форми</h6>
    <div v-for="(item, i) in data" :key="i" class="d-flex mb-1">
      <strong class="mr-1 text-nowrap">{{ item.label }}:</strong>
      <span v-if="item.type === 'checkbox'">
        {{ item.value ? "Так" : "Ні" }}
      </span>
      <a
        v-else-if="item.type === 'file' && item.value && item.value.file_url"
        :href="item.value.file_url"
        target="_blank"
      >
        {{ item.value.file_name || item.value.orig_path || "Відкрити файл" }}
      </a>
      <span v-else>{{ item.value || "—" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
};
</script>

<style lang="scss" scoped>
.form-data-view {
  h6 {
    font-size: 14px !important;
    color: #838b9d;
  }
  strong {
    font-size: 14px;
  }
  span,
  a {
    font-size: 14px;
  }
}
</style>
